import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    floatingPage: null,
    floatingPageStyle: null
  },
  mutations: {
    setFloatingPage (state, data) {
      const isOpen = state.floatingPage === data.pageId
      state.floatingPage = isOpen ? null : data.pageId
      state.floatingPageStyle = isOpen ? null : data.style 
    }
  },
  actions: {
  },
  getters: {
    getFloatingPage: state => state.floatingPage,
    getFloatingPageStyle: state => state.floatingPageStyle
  }
}
